'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';
import { SessionExpiredDialog } from '@/slw/widgets/auth/session-expired-dialog.ui';
import { useGlobalStore } from '@/slw/shared/stores';

interface SessionExpiredContextType {
  showSessionExpiredDialog: () => void;
  hideSessionExpiredDialog: () => void;
}

const SessionExpiredContext = createContext<SessionExpiredContextType | undefined>(undefined);

export const useSessionExpired = () => {
  const context = useContext(SessionExpiredContext);
  if (!context) {
    throw new Error('useSessionExpired must be used within a SessionExpiredProvider');
  }
  return context;
};

interface SessionExpiredProviderProps {
  children: ReactNode;
}

export const SessionExpiredProvider: React.FC<SessionExpiredProviderProps> = ({ children }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { openAuthModal } = useGlobalStore();

  const showSessionExpiredDialog = () => {
    setIsDialogOpen(true);
  };

  const hideSessionExpiredDialog = () => {
    setIsDialogOpen(false);
  };

  const handleLogin = () => {
    // Show auth modal (same as Sign Up/Log In button)
    openAuthModal();
  };

  const handleCancel = () => {
    // Redirect to search results page
    window.location.href = '/search-results/all-year?defaultFt=1';
  };

  return (
    <SessionExpiredContext.Provider value={{ showSessionExpiredDialog, hideSessionExpiredDialog }}>
      {children}
      <SessionExpiredDialog 
        isOpen={isDialogOpen} 
        onClose={hideSessionExpiredDialog}
        onLogin={handleLogin}
        onCancel={handleCancel}
      />
    </SessionExpiredContext.Provider>
  );
};
